"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This class is used to batch process telemetry data
let TeleBatchProcessor = class TeleBatchProcessor {
    capture(item) {
        this.batch.push(item);
        if (this.batch.length >= this.flushAt) {
            this.flushBackground();
        }
        if (this.flushInterval) {
            this.timeoutRef = setTimeout(()=>{
                this.flushBackground();
            }, this.flushInterval).unref();
        }
    }
    flushBackground() {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
            this.timeoutRef = null;
        }
        this.flush().catch(()=>{
        // do nothing
        });
    }
    async flush() {
        const batch = this.batch.splice(0, this.batch.length);
        if (!batch.length) {
            return;
        }
        await _axios.default.post('https://telemetry.nocodb.com/api/v1/telemetry', batch);
    }
    constructor({ flushAt = 100, flushInterval = 10000 } = {}){
        this.batch = [];
        this.flushAt = flushAt;
        this.flushInterval = flushInterval;
    }
};
const _default = TeleBatchProcessor;
